export const ADD_THANK_YOU = "ADD_THANK_YOU"
export const EDIT_THANK_YOU= "EDIT_THANK_YOU"
export const LIST_THANK_YOU = "LIST_THANK_YOU"
export const VIEW_THANK_YOU = "VIEW_THANK_YOU"
export const DELETE_THANK_YOU = "DELETE_THANK_YOU"

export const THANK_YOU_SUCCESS = "THANK_YOU_SUCCESS"
export const THANK_YOU_ERROR = "THANK_YOU_ERROR"
